// The diagonal up-right arrow that marks a link as opening in a new tab. Sized and
// drawn like SaveStatusIcon so the two read as one icon set.
//
// Inline rather than theme-components' `arrowLink.svg` for the same reason
// SaveStatusIcon is: this sits inside link text and has to take that link's
// colour, and an icon served as an `<img src>` URL carries its own.
export const ExternalLinkIcon: React.FC = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    style={{ flexShrink: 0, marginLeft: 3, verticalAlign: "baseline" }}
  >
    <path d="M6 3h7v7" />
    <path d="M13 3 3.5 12.5" />
  </svg>
);
